import React from 'react';
import { Modal, Button, Popconfirm } from 'antd';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& .ant-modal': {
      top: 0,
      paddingBottom: 0,
    },

    '& .ant-modal-close-x': {
      fontSize: 12,
      width: 44,
      height: 44,
      lineHeight: '44px',
    },

    '& .ant-modal-header': {
      padding: '32px 20px 20px 32px',
      borderBottom: 'none',

      '& .ant-modal-title': {
        fontSize: '18px',
        lineHeight: '24px',
        color: theme.colors.captionColor,
        fontWeight: 400,
      },
    },
    '& .ant-modal-body': {
      padding: 0,
      maxHeight: 'calc(100vh - 300px)',
      overflow: 'auto',
    },
    '& .ant-modal-footer': {
      padding: '16px 24px 16px 0',

      '& button + button': {
        marginLeft: 16,
      },

      '& .ant-btn span': {
        fontWeight: 500,
      },
    },
  },
  cancelButton: {
    borderColor: '#d9d9d9',
    marginRight: '16px',
  },
  okButton: {
    '& > span': {
      fontWeight: '600 !important',
    },
  },
}));

const CustomModal = ({
  children,
  wrapClassName,
  okText = 'Ok',
  onOk,
  okButtonProps,
  cancelText = 'Cancel',
  onCancel,
  cancelButtonProps,
  popconfirmProps,
  ...resetProps
}) => {
  const classes = useStyles();

  const defaultFooter = (
    <div>
      <Button
        size={'large'}
        type={'default'}
        onClick={onCancel}
        className={classes.cancelButton}
        {...cancelButtonProps}
      >
        {cancelText}
      </Button>
      <Popconfirm disabled={true} {...popconfirmProps}>
        <Button
          size={'large'}
          type={'primary'}
          onClick={onOk}
          className={classes.okButton}
          {...okButtonProps}
        >
          {okText}
        </Button>
      </Popconfirm>
    </div>
  );

  return (
    <Modal
      footer={defaultFooter}
      maskClosable={false}
      width={812}
      {...resetProps}
      okText={okText}
      onOk={onOk}
      closeIcon={
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.847 11.8486C11.6451 12.0505 11.3172 12.0505 11.1153 11.8486L6 6.73258L0.883101 11.8486C0.681203 12.0505 0.353321 12.0505 0.151423 11.8486C-0.0504745 11.6466 -0.0504745 11.3187 0.151423 11.1168L5.26832 6.00081L0.153039 0.88322C-0.0488593 0.681295 -0.0488593 0.353369 0.153039 0.151444C0.354936 -0.0504813 0.682818 -0.0504813 0.884716 0.151444L6 5.26903L11.1169 0.153059C11.3188 -0.0488659 11.6467 -0.0488659 11.8486 0.153059C12.0505 0.354984 12.0505 0.68291 11.8486 0.884835L6.73168 6.00081L11.847 11.1184C12.0489 11.3203 12.0489 11.6466 11.847 11.8486Z"
            fill="#999999"
          />
        </svg>
      }
      okButtonProps={okButtonProps}
      cancelText={cancelText}
      onCancel={onCancel}
      cancelButtonProps={cancelButtonProps}
      wrapClassName={classes.wrapper + ' ' + wrapClassName}
    >
      {children}
    </Modal>
  );
};

export default CustomModal;
